<template>
  <div class="modal standard-scheme" @click.self="cancel">
    <div class="modal-container">
      <header>
        <span>{{ __('Contributors') }}</span> <span v-if="totalPostAuthors > 0"> ({{ totalPostAuthors }}) </span>
      </header>
      <div class="list modal-list two-line-dense-list">
        <a
          v-for="contributor in registeredPostAuthors"
          :key="contributor.id"
          class="list-item is-actionable"
          :href="contributor.profile_url"
          target="_blank"
        >
          <div class="list-item-primary">
            <avatar-image :user="contributor" :width="36" :height="36" />
            <div>
              <div>{{ contributor.name || contributor.username }}</div>
              <div class="caption-type">{{ contributor.username }}</div>
            </div>
          </div>
        </a>
        <div v-if="anonymousPostAuthors.length > 0" class="list-item">
          <div class="list-item-primary">
            <avatar-image :width="36" :height="36" />
            <div>
              <div class="muted-type">{{ __('Anonymous contributors') }}</div>
              <div class="muted-type">{{ anonymousPostAuthors.length }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import AvatarImage from 'vuecomponents/avatar_image'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import { fetchJson } from '@padlet/fetch'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: { AvatarImage },
  mixins: [EscapeToCancelMixin],
  computed: {
    ...mapGetters(['wallId', 'builder']),
    ...mapGetters('userContributor', ['registeredPostAuthors', 'anonymousPostAuthors', 'totalPostAuthors']),
  },
  mounted() {
    // TODO: Escape key
    this.fetchPostAuthors()
  },
  methods: {
    ...mapActions({
      cancel: 'hideContributorsList',
    }),
    ...mapActions('userContributor', ['fetchPostAuthors']),
  },
}
</script>
